define('presentation/settings/billing/plans/viewModels/addPlanActionModalViewModel',[
    'i18next',
    'businessServices/converters/currencyFormatter',
    'common/promises/promiseFactory',
    'constants/billingPackageTypeConstants',
    'presentation/common/modal',
    'presentation/common/window/windowControl',
    'presentation/settings/billing/plans/facades/addPlanFacade'
], function () {
    return function (_currentPackage, _selectedPackage, _isPackageOnboardingComplete, _confirmCallback) {
        const self = this;

        const CurrencyFormatterConstructor = require('businessServices/converters/currencyFormatter');
        const _currencyFormatter = new CurrencyFormatterConstructor();

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _i18n = require('i18next');
        const _billingPackageTypes = require('constants/billingPackageTypeConstants');
        const _windowControl = require('presentation/common/window/windowControl');

        let _facade = null;
        let _modalService = null;

        const _isAddingPackage = () => {
            return self.currentPackage() === null && self.selectedPackage() !== null;
        };

        const _isCurrentPackage = (type) => {
            const currentPackageId = self.currentPackage() ? self.currentPackage().packageId : null;
            const selectedPackageId = self.selectedPackage() ? self.selectedPackage() : null;
            if (!currentPackageId && !selectedPackageId) {
                return false;
            }

            return currentPackageId === selectedPackageId;
        };

        const _formatSelectedPackageForDisplay = (pkg) => {
            const displayPackage = {};
            displayPackage.name = pkg.name;
            displayPackage.price = _currencyFormatter.formatUSDForDisplay(pkg.pricePerMonth);
            displayPackage.type = pkg.type;
            displayPackage.label = ko.pureComputed(() => {
                switch (pkg.type) {
                    case _billingPackageTypes.liveReceptionist.id:
                        return _i18n.t('addPlanActionModal:labelLiveReceptionist');
                    case _billingPackageTypes.webChat.id:
                        return _i18n.t('addPlanActionModal:labelWebChat');
                    case _billingPackageTypes.outboundCalling.id:
                        return _i18n.t('addPlanActionModal:labelOutboundCalling');
                    default:
                        return "";
                }
            });
            displayPackage.isRetired = pkg.isRetired;
            displayPackage.isActive = ko.pureComputed(() => {
                return _isCurrentPackage(pkg.type);
            });
            displayPackage.isOnboardingRequired = ko.pureComputed(() => {
                return _isAddingPackage(pkg.type) && pkg.isOnboardingRequired;
            });
            displayPackage.isOnboardingComplete = ko.pureComputed(() => {
                 if (displayPackage.isOnboardingRequired()) {
                     return false;
                 }
                return _isPackageOnboardingComplete;
            });
            displayPackage.tags = [
                {
                    isVisible: displayPackage.isActive() && displayPackage.isOnboardingComplete(),
                    cssClass: 'plans-list-item__tag--active',
                    label: _i18n.t('addPlanActionModal:tagActive')
                },
                {
                    isVisible: !displayPackage.isOnboardingComplete(),
                    cssClass: 'plans-list-item__tag--onboarding',
                    label: _i18n.t('addPlanActionModal:tagOnboarding')
                },
                {
                    isVisible: displayPackage.isRetired,
                    cssClass: '',
                    label: _i18n.t('addPlanActionModal:tagRetired')
                }
            ];

            return displayPackage;
        };

        self.currentPackage = ko.observable(null);
        self.selectedPackage = ko.observable(null);

        self.displaySelectedPackage = ko.pureComputed(() => {
            return _formatSelectedPackageForDisplay(self.selectedPackage());
        });

        self.showOnboardingMessage = ko.pureComputed(() => {
            if (self.displaySelectedPackage()) {
                return self.displaySelectedPackage().isOnboardingRequired();
            }
            return false;
        });

        self.submitAction = () => {
            return _promiseFactory.deferIndefinitely((promise) => {
                _confirmCallback()
                    .fail(promise.reject)
                    .done(promise.resolve);
            });
        };

        self.openTermsOfAgreement = () => {
            _windowControl.openTermsOfAgreement();
        };

        self.openContactUs = () => {
            _windowControl.openContactUs();
        };

        self.activate = () => {
            const FacadeConstructor = require('presentation/settings/billing/plans/facades/addPlanFacade');
            _facade = new FacadeConstructor();
            _facade.init(_promiseFactory);

            const ModalServiceConstructor = require('presentation/common/modal');
            _modalService = new ModalServiceConstructor();

            self.currentPackage(_currentPackage);
            self.selectedPackage(_selectedPackage);

            return _initialize();
        };

        const _initialize = () => {

            return _promiseFactory.wait();
        };
    };
});
